(() => {
  const ready = () => {
    document.querySelectorAll('[data-rp-configurator]').forEach((configurator) => {
      const root = configurator.closest('.rp-product');
      const price = root?.querySelector('.rp-price');
      const stickyPrice = document.querySelector('[data-rp-sticky-price]');
      const baseText = price?.textContent.trim() || stickyPrice?.textContent.trim() || '';
      const baseNumber = Number((baseText.match(/[\d,.]+/) || ['0'])[0].replace(/,/g, ''));
      const currency = baseText.match(/US\$|\$|€|£/)?.[0] || 'US$';
      const summaryPrice = configurator.querySelector('[data-rp-summary-price]');
      const nativeLabels = [...(root?.querySelectorAll('.rp-native-options label') || [])];
      const selectNativeValue = (value) => {
        nativeLabels.find((label) => label.textContent.trim().replace(/\s+/g, ' ').includes(value))?.click();
      };
      const updatePreviewPrice = (addAmount) => {
        const add = Number(addAmount || 0) / 100;
        if (baseNumber && (add || !nativeLabels.length)) {
          const updated = `${currency}${Math.round(baseNumber + add).toLocaleString('en-US')}`;
          if (!nativeLabels.length && price) price.textContent = updated;
          if (stickyPrice) stickyPrice.textContent = updated;
          if (summaryPrice) summaryPrice.textContent = updated;
        } else if (stickyPrice && price) {
          window.setTimeout(() => {
            stickyPrice.textContent = price.textContent.trim();
            if (summaryPrice) summaryPrice.textContent = price.textContent.trim();
          }, 80);
        }
      };

      configurator.querySelectorAll('fieldset').forEach((group) => {
        group.querySelectorAll('button').forEach((button) => {
          button.addEventListener('click', () => {
            group.querySelectorAll('button').forEach((item) => {
              const selected = item === button;
              item.classList.toggle('is-selected', selected);
              item.setAttribute('aria-pressed', selected ? 'true' : 'false');
            });

            const selectedValue = button.dataset.value || button.textContent.trim();
            selectNativeValue(selectedValue);
            const summaryValue = configurator.querySelector(`[data-rp-summary="${group.dataset.rpOption}"]`);
            if (summaryValue) summaryValue.textContent = selectedValue;
            updatePreviewPrice(button.dataset.priceAdd);
          });
        });

        group.querySelectorAll('[data-rp-select]').forEach((select) => {
          select.addEventListener('change', () => {
            const option = select.selectedOptions[0];
            selectNativeValue(option.value);
            if (select.hasAttribute('data-rp-price-select')) updatePreviewPrice(option.dataset.priceAdd);
          });
        });
      });
    });

    document.querySelectorAll('.rp-product .product-form__submit span').forEach((label) => {
      if (!/sold out|unavailable/i.test(label.textContent)) label.textContent = 'BUY NOW';
    });

    const checkoutNow = async (submit) => {
      const form = submit?.closest('form');
      if (!form || submit.disabled) return;
      submit.disabled = true;
      submit.classList.add('loading');
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
        });
        if (!response.ok) throw new Error(await response.text());
        window.location.assign(`${window.Shopify?.routes?.root || '/'}checkout`);
      } catch (error) {
        console.error('RAINA DIAMOND checkout error', error);
        submit.disabled = false;
        submit.classList.remove('loading');
      }
    };

    document.querySelectorAll('.rp-product .product-form__submit').forEach((submit) => {
      submit.addEventListener('click', (event) => {
        if (submit.disabled) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        checkoutNow(submit);
      }, true);
    });

    document.querySelector('[data-rp-buy-now]')?.addEventListener('click', () => {
      const submit = document.querySelector('.rp-product .product-form__submit:not([disabled])');
      if (submit) checkoutNow(submit);
      else {
        document.querySelector('.rp-summary')?.scrollIntoView({ behavior: 'smooth' });
      }
    });

    document.addEventListener('change', (event) => {
      if (!event.target.closest?.('.rp-product')) return;
      window.setTimeout(() => {
        const current = document.querySelector('.rp-product .rp-price')?.textContent.trim();
        if (current) document.querySelectorAll('[data-rp-sticky-price]').forEach((node) => { node.textContent = current; });
      }, 100);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
})();
